// post created, pre-approval
export const PENDING = 'PENDING';
export const APPROVED = 'APPROVED';
export const DECLINED = 'DECLINED';
// admin took no action and scheduled time past
export const EXPIRED = 'EXPIRED';
export const SENT = 'SENT';
export const CANCELLED = 'CANCELLED';
